import {map as createMap, icon as createIcon, marker as createMarker, GeoJSON, circleMarker} from "@smartmaps/maps";
import {Geocoder} from "@smartmaps/geocoding";
import {Routing} from "@smartmaps/routing";
import markerIcon from '../img/marker.svg';
import scrollToTop from "../../website/js/modules/scroll-top";

document.addEventListener('DOMContentLoaded', async function () {
    const isDetailPage = document.querySelector('.vp-detail-page');
    const isRoutingPage = document.querySelector('.vp-detail-routing');

    if (!(isDetailPage || isRoutingPage)) {
        return;
    }

    //Konstanten für den Map-Container und Inital-Daten
    const mapContainer = document.getElementById('map');
    const lat = mapContainer.dataset.ycoord;
    const lng = mapContainer.dataset.xcoord;
    const apiKey = '3%2BIrM%2Buvm2M5ynFYjCcLdp8qPrX7hyWiAnAExFzUh28%3D';

    //Karte initialisieren und Marker setzen
    const map = await createMap(mapContainer, apiKey, {
        center: [lat, lng], zoom: 14, minZoom: 6, zoomControl: false,
    });

    //Zoom-Button Text ändern
    L.control.zoom({
        zoomInTitle: "Karte vergrößern", zoomOutTitle: "Karte verkleinern", position: "topright"
    }).addTo(map);

    //Marker
    const icon = createIcon({
        iconUrl: markerIcon, iconSize: [30, 49], iconAnchor: [15, 49], popupAnchor: [0, -48]
    });

    const marker = createMarker({lat, lng}, {icon});
    marker.addTo(map);

    //Import von modules/scroll-top.js
    scrollToTop();

    /***** Start Logo Animation ******/
    const isSmallMobile = window.innerWidth <= 432;
    const offsetTop = 114;
    const header = document.querySelector('header');

    // Logo beim scrollen kleiner machen
    window.addEventListener('scroll', () => {

        if (!isSmallMobile) {
            if (window.scrollY >= offsetTop) {
                header.classList.add('big');
            } else {
                header.classList.remove('big');
            }
        }

    });
    /***** Ende Logo Animation ******/

    /***** Start Routen-Berechnung ******/
    if (isRoutingPage) {
        const userTarget = mapContainer.dataset.usertarget;
        const geocoder = new Geocoder(apiKey);
        const router = new Routing(apiKey);

        function formatDistance(meters) {
            if (meters < 1000) {
                return `${meters} m`;
            } else {
                const km = (meters / 1000).toFixed(1).replace('.', ',');
                return `${km} km`;
            }
        }

        function formatDuration(seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);

            if (hours > 0 && minutes > 0) {
                return `${hours}h ${minutes}min`;
            } else if (hours > 0) {
                return `${hours}h`;
            } else {
                return `${minutes}min`;
            }
        }


        const getGeoData = async function (userTarget) {

            const result = await geocoder.geocodeString(userTarget);

            if (!result.features || result.features.length === 0) {
                const routeDescriptionDiv = document.querySelector('.route-description');
                if (routeDescriptionDiv) {
                    routeDescriptionDiv.innerHTML = `<div class="error" role="alert">
                            Es konnte keine Route zum Ziel ermittelt werden. Bitte überprüfen Sie Ihre Eingabe.<br>
                            <a href="" title="Zurück zur Startseite">Zurück zur Suche</a>
                        </div>`;
                }
                return;
            }

            const coordinates = result.features[0].geometry.coordinates;
            return createMarker({lat: coordinates[1], lng: coordinates[0]}, {icon});
        };

        const startRouting = async function (userMarker) {

            const result = await router.calcRoute([marker.getLatLng(), userMarker.getLatLng()]);
            const distanceList = document.querySelector('.distance');
            const liDistance = document.createElement('li');
            const liDuration = document.createElement('li');

            liDistance.innerHTML = `<span class="icon-map-pin"></span> ${formatDistance(result.properties.distance)}`;
            liDuration.innerHTML = `<span class="icon-clock"></span> ${formatDuration(result.properties.duration)}`;

            distanceList.appendChild(liDistance);
            distanceList.appendChild(liDuration);

            let routingLayer = new GeoJSON(result, {
                style: feature => {
                    if (feature.geometry.type === 'LineString') {
                        return {
                            weight: 7, opacity: 0.8, color: '#DA1F3D'
                        }
                    }
                }, pointToLayer: (feature, latLng) => {
                    const circle = circleMarker(latLng, {
                        color: '#000000', fillOpacity: 0.8, fillColor: '#FFFFFF', radius: 5
                    });
                    const tableBody = document.querySelector('#route-description-table tbody');

                    if (tableBody && feature.properties.description && feature.properties.nextDistance !== undefined) {
                        const row = document.createElement('tr');

                        // Zelle 1: "nach 12m"
                        const cellDistance = document.createElement('td');
                        cellDistance.textContent = `nach ${formatDistance(feature.properties.nextDistance)}`;

                        // Zelle 2: Beschreibung
                        const cellDesc = document.createElement('td');
                        cellDesc.textContent = feature.properties.description;

                        // Zeile zusammenbauen
                        row.appendChild(cellDistance);
                        row.appendChild(cellDesc);
                        tableBody.appendChild(row);
                    }

                    circle.bindPopup(feature.properties.description);

                    return circle;
                }
            });
            //Bounding Koordinaten der Route auslesen
            const bounds = routingLayer.getBounds();

            userMarker.addTo(map);
            map.addLayer(routingLayer);
            map.fitBounds(bounds.pad(0.12));
        }

        const userMarker = await getGeoData(userTarget);
        userMarker.addTo(map);
        await startRouting(userMarker);
    }
    /***** Ende Routen-Berechnung ******/


    if (isDetailPage) {
        /***** Start mobile Layout Umstellung ******/
        const partnerServices = document.querySelector('.partner-services');
        const contentCol = document.querySelector('.content');
        const sidebar = document.querySelector('.sidebar');
        const accHeaders = document.querySelectorAll('.header');


        //Layout Logik: Initialer Zustand unbekannt
        let currentMobileView = null;
        //Event Logik: Initialer Zustand false
        let accBound = false;


        // Akkordeon öffnen/schließen
        function toggleAcc() {
            const accBody = this.nextElementSibling;
            const isOpen = accBody.classList.contains('open');
            const isMobile = window.innerWidth <= 1009;

            if (isOpen && isMobile) {
                //Zuklappen
                accBody.style.height = accBody.scrollHeight + 'px';
                accBody.style.height = '0px';
                accBody.classList.remove('open');
            } else {
                //Aufklappen
                accBody.classList.add('open');
                accBody.style.height = accBody.scrollHeight + 'px';
            }
        }

        // Handle Layout-Umsortierung
        function handleResize() {
            const isMobile = window.innerWidth <= 1009;

            // Nur reagieren, wenn sich der Modus geändert hat
            if (isMobile !== currentMobileView) {
                currentMobileView = isMobile;

                //Partner-Box verschieben
                if (isMobile && !sidebar.contains(partnerServices)) {
                    sidebar.appendChild(partnerServices);
                } else if (!isMobile && !contentCol.contains(partnerServices)) {
                    contentCol.appendChild(partnerServices);
                }

                //Akkordeon-Events verwalten
                accHeaders.forEach(header => {
                    if (isMobile && !accBound) {
                        header.addEventListener('click', toggleAcc);
                    } else if (!isMobile && accBound) {
                        header.removeEventListener('click', toggleAcc);
                    }
                });

                accBound = isMobile; // Status setzen
            }
        }

        // Initial ausführen & bei Resize
        handleResize();
        window.addEventListener('resize', handleResize);
        /***** Ende mobile Layout Umstellung ******/

            //Error-Handling Formular
        const form = document.getElementById('route-single-slot-form');
        const input = document.getElementById('vp_suche_detail_ort');
        const errorMessage = form.querySelector('.error');

        // Verhindere Browser-Standardmeldung
        input.addEventListener('invalid', function (e) {
            e.preventDefault(); // Unterdrückt native Meldung
            errorMessage.style.display = 'inline-block';
        });

        // Termin Overlay
        const terminLinks = document.querySelectorAll('a[href*="terminland.de"], a[href*="etermin.net"], a[href*="timify.com"], a[href*="calendly.com"]');
        terminLinks.forEach(terminLink => {
            const url = new URL(terminLink.href)
            if (url.hostname.toLowerCase().includes('terminland.de')) {
                url.searchParams.set('mode', 'frame')
            }
            terminLink.addEventListener('click', function (e) {
                e.preventDefault();
                const frameWidth = window.innerWidth > 1009 ? 800 : 360
                document.body.insertAdjacentHTML('beforeend', `
                        <div class="termin-overlay">
                            <div class="termin-overlay-inner">
                                <button class="btn btn-light icon-x termin-overlay-close" title="schließen"></button>
                                <iframe src="${url.href}" width="${frameWidth}" height="${window.innerHeight}"></iframe>
                            </div>
                        </div>
                    `,)

                document.querySelector('.termin-overlay')
                    .addEventListener('click', (event) => {
                        if (!event.target.classList.contains('termin-overlay-close') && !event.target.classList.contains('termin-overlay')) return;
                        document.querySelector('.termin-overlay').remove();
                    })
            });
        })

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                document.querySelector('.termin-overlay')?.remove();
            }
        })


        //Kontextmenü "Kontakt speichern"
        const trigger = document.querySelector('.kontakt-trigger');
        const menu = document.querySelector('.kontakt-auswahl');
        const qrCodeTrigger = document.querySelector('.qr-code-trigger');
        const qrCode = document.querySelector('.qr-code');


        trigger.addEventListener('click', function (event) {

            if (window.matchMedia('(max-width: 500px)').matches) return;

            event.preventDefault();

            menu.classList.add('is-open');

            //Positionierung des Kontextmenüs in der Nähe des Klicks

            //Ermittelt sichtbare Höhe und Breite des Menüs
            const menuWidth = menu.offsetWidth;
            const menuHeight = menu.offsetHeight;

            //Menü wird um den Klick herum positioniert
            let left = event.clientX - menuWidth / 2;
            let top = event.clientY + 10;

            const padding = 8; //Sicherheitsabstand zum Browserfenster

            if (left < padding) {
                left = padding;
            }

            if (left + menuWidth > window.innerWidth - padding) {
                left = window.innerWidth - menuWidth - padding;
            }

            if (top + menuHeight > window.innerHeight - padding) {
                top = event.clientY - menuHeight - 10;
            }

            menu.style.left = left + 'px';
            menu.style.top = top + 'px';
        });

        document.addEventListener('click', function (event) {
            if (!event.target.closest('.kontakt-button')) {
                menu.classList.remove('is-open');
            }
            if (event.target === qrCodeTrigger) {
                qrCode.classList.add('show');
                menu.classList.remove('is-open');
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                menu.classList.remove('is-open');
            }
        });
    }

});